import { useState } from "react";

import renderAlertConfirmationModal from "../Organisms/Modals/alert-confirmation-modal";

import { useModalContext } from "../Contexts/ModalContext";

import { useGetFidelCards, useGetFidelLinkData, useGetFidelPublicKey } from "./Queries";

import { fidelCustomStyles } from "../Utils/constants";
import { dispatchSuccessToast } from "../Utils/helpers";import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";


export default function useFidel({ onLinkingSuccess, onLinkingFailure, onFidelClose } = {}) {
  const [linkingCard, setLinkingCard] = useState(false);

  const modalContext = useModalContext();
  const { onModalClose } = modalContext;


  const { isLoading: isLoadingFidelPublicKey, data: fidelPublicKey } = useGetFidelPublicKey();
  const { isLoading: isLoadingFidelLinkData, data: fidelLinkData } = useGetFidelLinkData();
  const { data: fidelCards, refetch: refetchFidelCards } = useGetFidelCards();
  const navigate = useNavigate()

  const LinkCard = () => {
    if (fidelCards?.length >= 5) {
      renderAlertConfirmationModal(modalContext, {
        title: "Card Connection Limit Reached",
        description:
          "You've reached the maximum of 5 connected cards. To add a new one, remove an existing card first.",
        CTAButtonText: "Got it",
        hideSecondaryCTAButton: true,
        onCTAButtonClick: onModalClose,
      });
      return;
    }

    if (!window.Fidel) {
      console.error("Fidel SDK not loaded. Please refresh the page.");
      return;
    }

    if (!fidelPublicKey || !fidelLinkData?.program_id) {
      console.error("Fidel data not ready. Missing public key or program ID.");
      return;
    }

    setLinkingCard(true);

    try {
      window.Fidel.openForm({
        companyName: "Stake",
        sdkKey: fidelPublicKey,
        programId: fidelLinkData.program_id,
        metadata: fidelLinkData?.metadata ?? {},
        custom: fidelCustomStyles,
        onCardEnrolledCallback() {
          setLinkingCard(false);
          refetchFidelCards()
          navigate("/deals/neighborhood-network/linked-cards")
          dispatchSuccessToast("Your Card has been added successfully",{ alignToAppContent: true });       
          onLinkingSuccess?.();
        },
        onCardEnrollFailedCallback() {
          setLinkingCard(false);
          onLinkingFailure?.();
        },
        onUserCancelledCallback() {
          setLinkingCard(false);
          onFidelClose?.();
        },
      });
    } catch (err) {
      console.error("Fidel openForm error:", err);
      setLinkingCard(false);
    }
  };

  return { isLoadingFidel: isLoadingFidelPublicKey || isLoadingFidelLinkData, linkingCard, LinkCard };
}